/* eslint-disable default-param-last */
import { UPDATE_SELECTED_CONTRIBUTION } from "../actions/updateContributionData";

const initialState = {
  selectedContribution: null,
};

const updateContributionReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SELECTED_CONTRIBUTION:
      return {
        ...state,
        selectedContribution: action.payload,
      };
    default:
      return state;
  }
};

export default updateContributionReducer;
